const isRouteTariff = window.location.href.includes('/payment/tariffs');
const isRoutePlans = window.location.href.includes('/plans');

const appStoreCascadeurLink = 'https://apps.apple.com/us/app/cascadeur-3d-animation/id1612834671';
const tutorLink = '/tutor';

export const planHandlers = () => {
    if (!isRoutePlans && !isRouteTariff) {
        return;
    }

    $('.plans-secondary-banner').click(() => {
        window.location.href = tutorLink;
    });

    $('.pricing-tables__rules-link a').click(e => {
        e.preventDefault();

        const $faq = $('.plan-faq__title');
        const $question = $('#tariff-faq-discount-rules');

        if (!$faq.length && !$question.length) {
            return;
        }

        const $target = !$question.length ? $faq : $question;

        $('html, body').animate({
            scrollTop: $target.offset().top - 200,
        }, 1000);

        if ($target === $question) {
            $target.click();
        }
    });
};
